import React, { useState } from 'react';
import { FileCode2, Copy, Check } from 'lucide-react';

export default function CodeEditor({ content, fileName, copyTestId = 'code-editor-copy-button' }) {
  const [copied, setCopied] = useState(false);

  var copyToClipboard = function() {
    navigator.clipboard.writeText(content || '');
    setCopied(true);
    setTimeout(function() { setCopied(false); }, 2000);
  };

  var lines = (content || '// Select a file to view its contents').split('\n');

  return (
    <div className="flex flex-col h-full bg-[#0a0a0a]">
      <div className="flex items-center justify-between px-3 py-1.5 bg-[#111] border-b border-white/5">
        <div className="flex items-center gap-2">
          <FileCode2 className="w-3.5 h-3.5 text-zinc-500" />
          <span className="text-xs text-zinc-400 font-mono">{fileName || 'No file selected'}</span>
        </div>
        <button onClick={copyToClipboard} className="p-1 hover:bg-white/5 rounded transition-colors" data-testid={copyTestId}>
          {copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5 text-zinc-500" />}
        </button>
      </div>
      <div className="flex-1 overflow-auto font-mono text-xs leading-5">
        <table className="w-full">
          <tbody>
            {lines.map(function(line, i) {
              return (
                <tr key={i} className="hover:bg-white/[0.02]">
                  <td className="select-none text-right pr-4 pl-4 text-zinc-600 w-12 align-top">{i + 1}</td>
                  <td className="text-zinc-300 pr-4 whitespace-pre-wrap break-all">{line}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
